import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { AppToaster } from "@/components/Bits";
import Login from "@/pages/Login";
import Main from "@/pages/Main";
import CashFlow from "@/pages/world/CashFlow";
import Banking from "@/pages/world/Banking";
import {
  Events, Productions, SalesInvoices, PurchaseInvoices, IncomingPayments,
  OutgoingPayments, Reports, Realized, Warnings, WorldSettings,
} from "@/pages/world/WorldPages";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8F9FA]" data-testid="auth-loading">
        <div className="text-sm text-neutral-500">Yükleniyor…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Login />} />
      <Route path="/" element={<Navigate to="/main" replace />} />
      <Route path="/main" element={<Protected><Main /></Protected>} />
      <Route path="/etkinlikler" element={<Protected><Events /></Protected>} />
      <Route path="/uretimler" element={<Protected><Productions /></Protected>} />
      <Route path="/satis-faturalari" element={<Protected><SalesInvoices /></Protected>} />
      <Route path="/alis-faturalari" element={<Protected><PurchaseInvoices /></Protected>} />
      <Route path="/gelen-odemeler" element={<Protected><IncomingPayments /></Protected>} />
      <Route path="/giden-odemeler" element={<Protected><OutgoingPayments /></Protected>} />
      <Route path="/nakit-akisi" element={<Protected><CashFlow /></Protected>} />
      <Route path="/bankacilik" element={<Protected><Banking /></Protected>} />
      <Route path="/raporlar" element={<Protected><Reports /></Protected>} />
      <Route path="/gerceklesen" element={<Protected><Realized /></Protected>} />
      <Route path="/uyarilar" element={<Protected><Warnings /></Protected>} />
      <Route path="/ayarlar" element={<Protected><WorldSettings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRoutes />
            <AppToaster />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
